import React from 'react';

import _ from 'lodash';
import classnames from 'classnames';

import { getEventHostName } from 'shared/utils/common';

import EventDateTime from 'shared/components/EventDateTime';

import './styles.scss';

const Events = ({ event, className, onClick }) => {
  return (
    <div
      className={classnames('event-box-wrapper', className)}
      onClick={onClick}>
      <div className="event-datetime-wrapper">
        <EventDateTime event={event} />
      </div>
      <div className="event-info">
        <h4 className="title">{event.title}</h4>
        <div className="location">
          {!_.isNil(event.city) && `${event.city.name}, `}
          {!_.isNil(event.country) && event.country.name}
          {!_.isNil(event.host_vendor) &&
            `, Hosted by ${getEventHostName(event)}`}
        </div>
      </div>
      <div className="view-event">
        View Event <span className="material-icons">keyboard_arrow_right</span>
      </div>
    </div>
  );
};

export default Events;
